import { BadgeM } from "@common/components/badge/BadgeM"
import { theme } from "@common/theme/theme"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import React, { useState } from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import TouchableRippleM from "../../../common/components/button/TouchableRippleM"
import TodoListModal from "../todo/TodoListModal"

export const TodoIcon = (props) => {
    const { style, navigation, route } = props

    const todoActivities =
        props?.user?.todo_activities?.filter(
            (activity) => !activity.isDeleted
        ) ?? []

    const todoCount = Math.max(0, todoActivities.length)

    const [showTodoListModal, setShowTodoListModal] = useState(false)

    const toggleTodoListModal = () => {
        setShowTodoListModal(!showTodoListModal)
    }

    return (
        <View>
            <TouchableRippleM
                onPress={toggleTodoListModal}
                style={{
                    padding: 8,
                    ...style,
                }}
            >
                <View>
                    <FontAwesome5
                        name="bars"
                        size={32}
                        color={theme.colors.primary}
                    />
                    <BadgeM
                        style={{
                            position: "absolute",
                            top: -5,
                            right: -5,
                            backgroundColor:
                                todoCount > 0
                                    ? theme.colors.primary
                                    : theme.colors.success,
                            color: theme.colors.white,
                        }}
                        count={todoCount > 0 ? todoCount : null}
                        customContent={
                            todoCount === 0 ? (
                                <FontAwesome5
                                    name="check"
                                    size={10}
                                    color={theme.colors.white}
                                />
                            ) : null
                        }
                        size={18}
                    />
                </View>
            </TouchableRippleM>
            <TodoListModal
                visible={showTodoListModal}
                onClose={() => setShowTodoListModal(false)}
                todoActivities={todoActivities}
                student={props.user}
                navigation={navigation}
                route={route}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        liveSessionId: state.liveMode?.liveSessionId,
        isLiveMode: state.liveMode.isLiveModeEnabled,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(TodoIcon)
